var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVentillation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_1",
    "data-name": 1,
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.288,
    height: 38.349,
    viewBox: "0 0 37.288 38.349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(2.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M0,38.349V13.778L15.009,0l6.754,6.2V4.363h3.5V9.415l4.753,4.363V38.349Z",
    fill: "#e1f4fb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2",
    "data-name": "Path 2",
    transform: "translate(2.294 3.142)",
    fill: "#e1f4fb",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24.6758975982666 32.32383346557617 L 0.7499978542327881 32.32383346557617 L 0.7499978542327881 11.8457555770874 L 12.71541213989258 1.011848449707031 L 24.6758975982666 11.84565544128418 L 24.6758975982666 32.32383346557617 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12.71530532836914 2.023683547973633 L 1.499998092651367 12.17842483520508 L 1.499998092651367 31.57382583618164 L 23.9258975982666 31.57382583618164 L 23.9258975982666 12.17824554443359 L 12.71530532836914 2.023683547973633 M 12.71550750732422 -3.814697265625e-06 L 25.4258975982666 11.51307487487793 L 25.4258975982666 33.07382583618164 L -1.9073486328125e-06 33.07382583618164 L -1.9073486328125e-06 11.51307487487793 L 12.71550750732422 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "breathable",
    transform: "translate(12.357 14.314) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M.266,3.416A.7.7,0,0,0,1.228,3.3l.58-.72A3.461,3.461,0,0,0,2.3,4.191a2.172,2.172,0,0,1,0,2.248L1.9,7.114a4.748,4.748,0,0,0,0,4.915.691.691,0,0,0,.594.328.706.706,0,0,0,.343-.088.644.644,0,0,0,.25-.9,3.475,3.475,0,0,1,0-3.6L3.489,7.1a3.446,3.446,0,0,0,0-3.566A2.179,2.179,0,0,1,3.183,2.6l.566.7a.706.706,0,0,0,.962.118.64.64,0,0,0,.123-.923L3.031.255a.7.7,0,0,0-1.084,0L.143,2.493A.64.64,0,0,0,.266,3.416Z",
    transform: "translate(0)",
    fill: "#00a3da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M.266,3.416A.706.706,0,0,0,1.228,3.3l.58-.72A3.46,3.46,0,0,0,2.3,4.191a2.172,2.172,0,0,1,0,2.248L1.9,7.114a4.748,4.748,0,0,0,0,4.915.691.691,0,0,0,.594.329.707.707,0,0,0,.343-.089.643.643,0,0,0,.25-.9,3.475,3.475,0,0,1,0-3.6L3.489,7.1a3.446,3.446,0,0,0,0-3.566A2.183,2.183,0,0,1,3.183,2.6l.566.7a.7.7,0,0,0,.962.118.64.64,0,0,0,.123-.923L3.031.255a.7.7,0,0,0-1.084,0L.143,2.493a.64.64,0,0,0,.123.923Z",
    transform: "translate(6.758 0)",
    fill: "#00a3da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M.266,3.416A.706.706,0,0,0,1.228,3.3l.58-.72A3.461,3.461,0,0,0,2.3,4.191a2.172,2.172,0,0,1,0,2.248L1.9,7.114a4.748,4.748,0,0,0,0,4.915.691.691,0,0,0,.594.328.706.706,0,0,0,.343-.088.644.644,0,0,0,.25-.9,3.475,3.475,0,0,1,0-3.6L3.489,7.1a3.446,3.446,0,0,0,0-3.566A2.186,2.186,0,0,1,3.183,2.6l.566.7a.7.7,0,0,0,.962.118.64.64,0,0,0,.123-.923L3.031.255a.7.7,0,0,0-1.084,0L.143,2.493A.64.64,0,0,0,.266,3.416Z",
    transform: "translate(13.516)",
    fill: "#00a3da"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "breathable-2",
    "data-name": "breathable",
    transform: "translate(37.288 14.314) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M.266,3.416A.7.7,0,0,0,1.228,3.3l.58-.72A3.461,3.461,0,0,0,2.3,4.191a2.172,2.172,0,0,1,0,2.248L1.9,7.114a4.748,4.748,0,0,0,0,4.915.691.691,0,0,0,.594.328.706.706,0,0,0,.343-.088.644.644,0,0,0,.25-.9,3.475,3.475,0,0,1,0-3.6L3.489,7.1a3.446,3.446,0,0,0,0-3.566A2.179,2.179,0,0,1,3.183,2.6l.566.7a.706.706,0,0,0,.962.118.64.64,0,0,0,.123-.923L3.031.255a.7.7,0,0,0-1.084,0L.143,2.493A.64.64,0,0,0,.266,3.416Z",
    transform: "translate(0)",
    fill: "#00a3da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M.266,3.416A.706.706,0,0,0,1.228,3.3l.58-.72A3.46,3.46,0,0,0,2.3,4.191a2.172,2.172,0,0,1,0,2.248L1.9,7.114a4.748,4.748,0,0,0,0,4.915.691.691,0,0,0,.594.329.707.707,0,0,0,.343-.089.643.643,0,0,0,.25-.9,3.475,3.475,0,0,1,0-3.6L3.489,7.1a3.446,3.446,0,0,0,0-3.566A2.183,2.183,0,0,1,3.183,2.6l.566.7a.7.7,0,0,0,.962.118.64.64,0,0,0,.123-.923L3.031.255a.7.7,0,0,0-1.084,0L.143,2.493a.64.64,0,0,0,.123.923Z",
    transform: "translate(6.758 0)",
    fill: "#00a3da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M.266,3.416A.706.706,0,0,0,1.228,3.3l.58-.72A3.461,3.461,0,0,0,2.3,4.191a2.172,2.172,0,0,1,0,2.248L1.9,7.114a4.748,4.748,0,0,0,0,4.915.691.691,0,0,0,.594.328.706.706,0,0,0,.343-.088.644.644,0,0,0,.25-.9,3.475,3.475,0,0,1,0-3.6L3.489,7.1a3.446,3.446,0,0,0,0-3.566A2.186,2.186,0,0,1,3.183,2.6l.566.7a.7.7,0,0,0,.962.118.64.64,0,0,0,.123-.923L3.031.255a.7.7,0,0,0-1.084,0L.143,2.493A.64.64,0,0,0,.266,3.416Z",
    transform: "translate(13.516)",
    fill: "#00a3da"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentillation);
export default __webpack_public_path__ + "static/media/ventillation.4c9eeb3f9eed3603ffa2004a2e360559.svg";
export { ForwardRef as ReactComponent };